import TanStackTable from '../../../../components/Table/TanStackTable/TanStackTable'
import useSalesInstallments from '../../../../hooks/Sales/SalesInstallments/useSalesInstallments'
import './SalesInstallmentsView.css'
import StudentModal from "../../../../components/StudentModal/StudentModal";
import ContentCreator from "../../../../components/ContentCreator/ContentCreator";
import { SalesInstallmentsPreview } from "../../SalesInstallmentsPreview/SalesInstallmentsPreview";
import SalesInstallmentsForm from "../../SalesInstallmentsForm/SalesInstallmentsForm";
import { DatePickerInput } from '@mantine/dates';
import SalesInstallmentsConfirmModal from '../../../../components/SalesInstallmentsConfirmModal/SalesInstallmentsConfirmModal';
import { Modal, Button } from '@mantine/core';
import { InstallmentsModal } from '../../../../components/InstallmentsModal/InstallmentsModal';
import { Link } from 'react-router-dom'

export default function SalesInstallmentsView() {

    const {
        data,
        columns,
        isLoading,
        studentData,
        setStudentData,
        editInstallments,
        displayForm,
        setDisplayForm,
        initialValuesEdit,
        setInitialValuesEdit,
        editPaymentStateAction,
        handleSubmitForm,
        dateFilter,
        setDateFilter,
        onChangeStateInstallmentsSwitch,
        confirmModalData,
        onCloseConfirmModal,
        isSwitchLoading,
        detailsModal,
        onCloseDetailsModal,
        formatDate
    } = useSalesInstallments()



    return (
        <section className='SalesInstallmentsView-main-container'>
            {!displayForm &&
                <div className="AdministrativeExpensesView__filters">
                    <DatePickerInput
                        classNames={{ root: "moderationContainer-DatePicker-root" }}
                        type="range"
                        label="Mostrando datos de:"
                        value={dateFilter}
                        onChange={(value) => setDateFilter(value)}
                    />
                    <span>
                        * Por defecto se muestran datos del mes actual (desde el 1ro hasta la fecha actual)
                    </span>
                    <Button
                        mt={10}
                        type='button'
                        variant='outline'
                        maw='max-content'
                        component={Link}
                        to={`/admin/administracion/vencimientos?initDate=${formatDate(dateFilter[0])}&endDate=${formatDate(dateFilter[1])}`}
                    >
                        Notificar vencimientos
                    </Button>

                </div>

            }
            {displayForm && (
                <ContentCreator
                    title={"Editar cuotas"}
                    submitFunc={(values) => handleSubmitForm(values)}
                    onCancel={() => {
                        setDisplayForm(false)
                        setInitialValuesEdit(null)
                    }}
                    initialValues={initialValuesEdit}
                    renderPreview={(_form) => (
                        <SalesInstallmentsPreview rowData={_form.form.values} />
                    )}
                    renderForm={(_form) => (
                        <SalesInstallmentsForm form={_form.form} loading={isLoading} />
                    )}
                />
            )}

            {!displayForm && (
                < TanStackTable
                    data={data}
                    columns={columns}
                    loading={isLoading}
                    editFunc={editInstallments}
                    actionsFunc={(rowData) => editPaymentStateAction(rowData)}
                />
            )}

            {studentData && (
                <StudentModal
                    open={studentData}
                    setOpen={() => setStudentData(null)}
                    studentData={studentData}
                />
            )}
            {confirmModalData && (
                <SalesInstallmentsConfirmModal
                    isLoading={isSwitchLoading}
                    installment={confirmModalData}
                    onClose={onCloseConfirmModal}
                    onConfirmFunction={onChangeStateInstallmentsSwitch}
                    opened={confirmModalData}
                />
            )}
            {detailsModal && <Modal
                opened={detailsModal}
                onClose={onCloseDetailsModal}
            >
                <InstallmentsModal
                    isInstallmentDetailsModal={detailsModal?.map(item => ({ ...item, _id: item.installment_id }))}
                    onClose={onCloseDetailsModal}
                />
            </Modal>}
        </section>
    )
}